import { FeatureName, ModuleName } from "./product";
import {
  adminArchive,
  adminArticles,
  adminBeneficialOwners,
  adminDashboard,
  adminEntityData,
  adminFinancialInstruments,
  adminMessaging,
  adminOverview,
  adminOwnership,
  adminPoA,
  adminProjects,
  adminRoles,
  adminSettings,
  adminShareholdersCapTable,
  adminShareholdersDashboard,
  adminShareholdersList,
  adminShareholdersShareClasses,
  adminShareholdersShareholderCommitments,
  adminShareholderStatement,
  adminShareholdersTransactions,
} from "@/utils/navigation";
import { ArchiveRootFolderType } from "@/archive/commonArchiveDomain";
import { CustomRole } from "./customRole";

export const moduleUrl = (moduleName: ModuleName, orgNo: string): string => {
  switch (moduleName) {
    case ModuleName.OVERVIEW:
      return adminOverview(orgNo);
    case ModuleName.SHAREHOLDER_REGISTER:
      return adminShareholdersList(orgNo);
    case ModuleName.DBOT:
      return adminProjects(orgNo);
    case ModuleName.MESSAGING:
      return adminMessaging(orgNo);
    case ModuleName.ARCHIVE:
      return adminArchive({ orgNo });
    case ModuleName.OWNERSHIP_REGISTER:
      return adminShareholdersList(orgNo);
  }
};

export const featureUrl = (feature: FeatureName, orgNo: string): string => {
  switch (feature) {
    case FeatureName.dashboard:
      return adminDashboard(orgNo);
    case FeatureName.entityData:
      return adminEntityData(orgNo);
    case FeatureName.articles:
      return adminArticles(orgNo);
    case FeatureName.poas:
      return adminPoA(orgNo);
    case FeatureName.ownership:
      return adminOwnership(orgNo);
    case FeatureName.companyRoles:
      return adminRoles(orgNo);
    case FeatureName.companySettings:
      return adminSettings(orgNo);
    case FeatureName.shareholderRegisterDashboard:
      return adminShareholdersDashboard(orgNo);
    case FeatureName.shareholders:
      return adminShareholdersList(orgNo);
    case FeatureName.transactions:
      return adminShareholdersTransactions(orgNo);
    case FeatureName.shareClasses:
      return adminShareholdersShareClasses(orgNo);
    case FeatureName.financialInstruments:
      return adminFinancialInstruments(orgNo);
    case FeatureName.capTable:
      return adminShareholdersCapTable(orgNo);
    case FeatureName.commitments:
      return adminShareholdersShareholderCommitments(orgNo);
    case FeatureName.shareholderRegisterStatement:
      return adminShareholderStatement(orgNo);
    case FeatureName.beneficialOwners:
      return adminBeneficialOwners(orgNo);
    case FeatureName.owners:
      return adminShareholdersList(orgNo);
    case FeatureName.ownersTransactions:
      return adminShareholdersTransactions(orgNo);
    case FeatureName.ownersShareClasses:
      return adminShareholdersShareClasses(orgNo);
    case FeatureName.freetext:
    case FeatureName.companyEvents:
    case FeatureName.liveGeneralMeeting:
    case FeatureName.increaseOfShareCapital:
      return adminProjects(orgNo);
    case FeatureName.boardArchive:
      return adminArchive({
        orgNo,
        folderId: undefined,
        folderType: ArchiveRootFolderType.BOARD_ARCHIVE,
      });
    case FeatureName.shareholderArchive:
      return adminArchive({
        orgNo,
        folderId: undefined,
        folderType: ArchiveRootFolderType.SHAREHOLDER_ARCHIVE,
      });
    case FeatureName.adminArchive:
      return adminArchive({
        orgNo,
        folderId: undefined,
        folderType: ArchiveRootFolderType.ADMIN_ARCHIVE,
      });
    case FeatureName.customArchives:
      return adminArchive({
        orgNo,
        folderId: undefined,
        folderType: ArchiveRootFolderType.CUSTOM_ARCHIVE,
      });
    case FeatureName.boardMessages:
    case FeatureName.shareholderMessages:
      return adminMessaging(orgNo);
  }
};

const modulesWithoutFeatures: ModuleName[] = [ModuleName.DBOT];

export const findInitialUrl = ({ role, orgNo }: { role: CustomRole; orgNo: string }): string => {
  if (modulesWithoutFeatures.includes(role.modules[0])) {
    return moduleUrl(role.modules[0], orgNo);
  }

  const firstFeature = Object.values(FeatureName).find((f) =>
    role.features.some((a) => a.access !== "NONE" && f === a.featureName),
  );
  if (firstFeature) {
    return featureUrl(firstFeature, orgNo);
  } else {
    return moduleUrl(role.modules[0], orgNo);
  }
};
